export default __webpack_public_path__ + "static/media/Fraction_08.ddc4427e.png";